import React from 'react';
import {useTheme} from '@mui/material';
import LocationPriceInfoBoxBase from './LocationPriceInfoBoxBase';
import {IInfoBox} from "./interfaces";

/**
 * Gray map pin shown for locations with zero available capacity today.
 * Reuses the shared price-pin shell with a dark-gray color override instead
 * of the success/warning severity colors.
 */
const AtCapacityInfoBox = (props: IInfoBox) => {
  const {formattedPrice, onClick, listHover} = props;
  const theme = useTheme();

  return <LocationPriceInfoBoxBase formattedPrice={formattedPrice}
                                   onClick={onClick}
                                   pinColor={theme.palette.grey[700]}
                                   listHover={listHover}
  />
}

export default AtCapacityInfoBox;
